/**
 * Application entry point
 */

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './SidebarFix.css'
import { PinocchioProvider } from './contexts/PinocchioContext.tsx'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PinocchioProvider>
      <App />
    </PinocchioProvider>
  </React.StrictMode>,
)
